import { ILiveCategoryLinkQuery } from '../interfaces/live-category-link.query.interface';

// @dynamic
export class LiveCategoryLink {
    id: string;
    audience: { id: string };
    featuredStream: { id: string };
    category: {
        id: string;
        name: string;
        type: string;
        breadcrumbs: string;
    };

    constructor(query: ILiveCategoryLinkQuery) {
        this.id = query.id.toString();
        this.audience = { id: query.audience.id.toString() };
        this.featuredStream = { id: query.featured_stream.id.toString() };
        this.category = { id: query.category.id.toString(), name: query.category.name, type: query.category.type, breadcrumbs: query.category.breadcrumbs };
    }
}
